import { Box, Link, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const CachedMessagesHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>Cached Messages</h3>
      <ul>
        <li>Items are saved across sessions</li>
        <li>Bulk operations available</li>
        <li>Price calculations in real-time</li>
      </ul>
    </Box>
    <Box>
      <h3>Need Help?</h3>
      <Link href="#" external>
        Contact customer support
      </Link>
    </Box>
  </SpaceBetween>
);

export default CachedMessagesHelpPanel;
